import ChatRoomVue from '@/views/sic/chat-room/chat-room.vue';

const basePath = '/sic/chat-room';
const role = 'sic'; // 角色身份

export const SIC_CHAT_ROOM_INDEX = 'sic-chat-room-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ChatRoomVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_CHAT_ROOM_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/chat-room/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
